/* eslint-disable */
import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config";
import { showToast } from "../components/toast";
import LoadingSpinner from "../components/LoadingSpinner";
import Swal from "sweetalert2";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faLink } from "@fortawesome/free-solid-svg-icons";

const AddUtmLink = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const stypeParam = queryParams.get("stype");
  const currentStype = stypeParam === "folio" ? "folio" : "streetgains";

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    pagename: "",
    utm_source: "",
    utm_campaign: "",
    utm_medium: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate fields
    if (!formData.pagename.trim()) {
      showToast.error("Please enter Page Name");
      return;
    }

    if (!formData.utm_source.trim()) {
      showToast.error("Please enter UTM Source");
      return;
    }

    if (!formData.utm_campaign.trim()) {
      showToast.error("Please enter UTM Campaign");
      return;
    }

    if (!formData.utm_medium.trim()) {
      showToast.error("Please enter UTM Medium");
      return;
    }

    try {
      setLoading(true);

      const payload = {
        pagename: formData.pagename.trim(),
        utm_source: formData.utm_source.trim(),
        utm_campaign: formData.utm_campaign.trim(),
        utm_medium: formData.utm_medium.trim(),
        stype: currentStype, // directly sends 'streetgains' or 'folio' based on active tab
      };

      const response = await axios.post(`${API_URL}utm-links`, payload);

      if (response.data && response.data.success) {
        const createdLink = response.data.data?.short_url || "";
        showToast.success("UTM short link generated successfully");

        // Show result popup with copy option
        Swal.fire({
          title: "Short Link Generated!",
          html: `
            <div style="margin: 15px 0;">
              <p style="font-size: 14px; color: #555; margin-bottom: 8px;">Your shortened campaign link is ready:</p>
              <div style="background: #f1f5f9; padding: 12px; border-radius: 6px; font-weight: bold; font-family: monospace; font-size: 16px; border: 1px solid #cbd5e1; user-select: all;">
                ${createdLink}
              </div>
            </div>
          `,
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "Copy Link & Go to List",
          cancelButtonText: "Go to List",
          confirmButtonColor: "#3085d6",
        }).then((result) => {
          if (result.isConfirmed) {
            navigator.clipboard.writeText(
              createdLink.startsWith("http") ? createdLink : `https://${createdLink}`
            );
            showToast.success("Copied to clipboard!");
          }
          navigate("/utm-links");
        });
      } else {
        const errorMessage = response.data?.message || "Failed to generate UTM link";
        showToast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error creating UTM link:", error);
      const errorMessage =
        error.response?.data?.message || "Failed to generate UTM link. Please try again.";
      showToast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/utm-links");
  };

  const isStreetgains = currentStype === "streetgains";

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content" className="">
        {loading && <LoadingSpinner />}

        {/* Page Title Row */}
        <div className="row pb-2">
          <div className="col-md-6">
            <h4 className="panel-title pull-left">
              <FontAwesomeIcon icon={faLink} className="me-2 text-primary" />{" "}
              Add {isStreetgains ? "Streetgains" : "Streetfolio"} UTM Link
            </h4>
          </div>
          <div className="col-md-6" style={{ textAlign: "right" }}>
            <Link to="/utm-links" className="btn btn-default btn-sm">
              <FontAwesomeIcon icon={faArrowLeft} /> Back to UTM Links
            </Link>
          </div>
        </div>

        {/* Form Panel */}
        <div className="panel panel-default with-rounded-corner with-shadow">
          <div className="panel-heading border-0 d-flex justify-content-between align-items-center">
            <h4 className="panel-title m-0">
              {isStreetgains ? "Streetgains" : "Streetfolio"} Link Details
            </h4>
            <span
              className="badge"
              style={{
                backgroundColor: isStreetgains ? "#348fe2" : "#00acac",
                color: "#ffffff",
                fontSize: "12px",
                padding: "6px 12px",
              }}
            >
              Domain: {isStreetgains ? "strg.in/XXXX" : "sfol.in/XXXX"}
            </span>
          </div>
          <div className="panel-body">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Page Name */}
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="control-label" style={{ fontWeight: "600" }}>
                      Page Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="pagename"
                      value={formData.pagename}
                      onChange={handleInputChange}
                      className="form-control"
                      disabled={loading}
                      required
                    />
                  </div>
                </div>

                {/* UTM Source */}
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="control-label" style={{ fontWeight: "600" }}>
                      UTM Source <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="utm_source"
                      value={formData.utm_source}
                      onChange={handleInputChange}
                      className="form-control"
                      disabled={loading}
                      required
                    />
                  </div>
                </div>

                {/* UTM Campaign */}
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="control-label" style={{ fontWeight: "600" }}>
                      UTM Campaign <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="utm_campaign"
                      value={formData.utm_campaign}
                      onChange={handleInputChange}
                      className="form-control"
                      disabled={loading}
                      required
                    />
                  </div>
                </div>

                {/* UTM Medium */}
                <div className="col-md-6 mb-3">
                  <div className="form-group">
                    <label className="control-label" style={{ fontWeight: "600" }}>
                      UTM Medium <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="utm_medium"
                      value={formData.utm_medium}
                      onChange={handleInputChange}
                      className="form-control"
                      disabled={loading}
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="d-flex gap-2 mt-4">
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading}
                  style={{ marginRight: "10px" }}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Generating...
                    </>
                  ) : (
                    "Generate Short Link"
                  )}
                </button>
                <button
                  type="button"
                  onClick={handleCancel}
                  className="btn btn-danger"
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddUtmLink;
